export default function Modal({children, closeCallback}) {
    return (
        <dialog id="editMedia" className="modal" open>
            <button className="modal__close" onClick={closeCallback}>&times;</button>
            <div className="modal__container">
                {children}
            </div>
        </dialog>
    )
}